// extracted by mini-css-extract-plugin
export default {"component":"MainPart_component__Rg0oJ","imgContainer":"MainPart_imgContainer__dfTEm","mainImg":"MainPart_mainImg__KTcd-","secondImg":"MainPart_secondImg__y0dgX"};